export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const isPreview = () =>
  process.env.VERCEL_ENV === "preview" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

export const isStaging = () => {
  if (typeof window !== "undefined") {
    return window.location.hostname === "zapier-staging.com";
  }
  // Server-side we look at which branch we are working off of
  return process.env.VERCEL_GIT_COMMIT_REF === "staging";
};

export const isDev = () => {
  return process.env.NEXT_PUBLIC_VERCEL_ENV === "development";
};
